import setPrices from './set-prices';
import setBillingProfiles from './set-billing-profiles';

export default {
  setPrices,
  setBillingProfiles,
};
